export var CONTROL_SIZE;
(function (CONTROL_SIZE) {
    CONTROL_SIZE[CONTROL_SIZE["xxs"] = 1] = "xxs";
    CONTROL_SIZE[CONTROL_SIZE["xs"] = 2] = "xs";
    CONTROL_SIZE[CONTROL_SIZE["s"] = 3] = "s";
    CONTROL_SIZE[CONTROL_SIZE["m"] = 4] = "m";
    CONTROL_SIZE[CONTROL_SIZE["l"] = 5] = "l";
    CONTROL_SIZE[CONTROL_SIZE["xl"] = 6] = "xl";
    CONTROL_SIZE[CONTROL_SIZE["xxl"] = 7] = "xxl";
    CONTROL_SIZE[CONTROL_SIZE["full"] = 8] = "full";
})(CONTROL_SIZE || (CONTROL_SIZE = {}));
export var ARROW_DIRECTION;
(function (ARROW_DIRECTION) {
    ARROW_DIRECTION["up"] = "up";
    ARROW_DIRECTION["down"] = "down";
    ARROW_DIRECTION["left"] = "left";
    ARROW_DIRECTION["right"] = "right";
})(ARROW_DIRECTION || (ARROW_DIRECTION = {}));
export var STATUSES;
(function (STATUSES) {
    STATUSES["info"] = "info";
    STATUSES["success"] = "success";
    STATUSES["warning"] = "warning";
    STATUSES["error"] = "error";
})(STATUSES || (STATUSES = {}));
export var SCROLL_TO_TYPE;
(function (SCROLL_TO_TYPE) {
    SCROLL_TO_TYPE[SCROLL_TO_TYPE["top"] = 0] = "top";
    SCROLL_TO_TYPE[SCROLL_TO_TYPE["bottom"] = 1] = "bottom";
})(SCROLL_TO_TYPE || (SCROLL_TO_TYPE = {}));
//# sourceMappingURL=public.js.map